module.exports = __webpack_public_path__ + "img/muna-full-md.4b99a1fb.jpg";